<ng-container *ngIf="loaded">
  <ng-container [ngTemplateOutlet]="tabContent">
  </ng-container>
</ng-container>